import { useMutation } from '@tanstack/react-query';
import { updateUserSettingsService } from './Users.services';
import { toastFlashMessage } from 'utils';

export const useUpdateUserSettingsMutation = () =>
  useMutation(updateUserSettingsService, {
    onSuccess: () => toastFlashMessage('User settings saved', 'success'),
  });
